export function getDefaultConfiguration() {
  return process.env.BARAEM_API === 'production' ? {
    webserviceKey: 'qIs11DijUTH3viwIxEsuBIh33raj3drI',
    apiUrl: 'https://proxies-beinmena.portail.alphanetworks.be/proxy/',
  } : {
    webserviceKey: '8agiHAxEQLfro6hemuresowatrucicOt',
    apiUrl: 'https://uat-proxies-beinmena.portail.alphanetworks.be/proxy/',
  };
}
